import { cDisplay } from "../creator/cDisplay";
import { cGame } from "../creator/cGame";
import { cButton } from "../creator/cGameObjects/cButton";
import { cContainer } from "../creator/cGameObjects/cContainer";
import { cInlineDisplay } from "../creator/cGameObjects/cInlineDisplay";
import { cSprite } from "../creator/cGameObjects/cSprite";
import { cTextSprite } from "../creator/cGameObjects/cTextSprite";
import { cScene } from "../creator/cScene";
import { ScreenItem } from "../creator/dataTypes";

export class gamePoliceDisplay extends cDisplay {
  private ccList: number[];
  private curSlide: any;
  private selected: string[] = [];
  private qData: any;
  private cc: number = 0;
  private score: number = 0;
  private eyes: Eye[]

  init() {
    super.init();

    this.score = 0;

    (this.scene as cScene).ev.addListener("action", (command, options) => {
      switch (options.command) {
        case "start":
          this.selected = [];
          var c: cContainer = this.getByName("DATA") as cContainer;
          this.qData = [...c.modules.data._extraData];
          this.ccList = [...c.modules.data._extraData];
          this.ccList.sort((e) => 0.5 - Math.random());
          this.next_question();
          break;

        case "next_question":
          this.next_question();
          break;

        case "popup":
          var banners: string[] = [
            "banner_1",
            "banner_2",
            "banner_3",
            "banner_4",
            //"question",
          ];
          var delays: number[] = [10, 12, 13, 14].sort((i) => 0.5 - Math.random());

          delays.push(0)
          this.showHideButtons(true);
          banners.forEach((nm, i) => {
            var el = this.getByName(nm) as cTextSprite;

            if (!(el as any).yy) {
              (el as any).yy = el.y;
            }

            var yy = (el as any).yy;
            el.y = 1080 + 600;
            el.visible = true;
            el.scaleY = 1;
            this.scene.tweens.add({
              targets: el,
              y: yy,
              duration: 400,
              angle: (0.5 - Math.random()) * 10,
              scaleY: 1,
              ease: "Back.easeOut",
              delay: delays[i] * 100,
            });
          });
          //this.getByName('question').angle = 0;
          break;

        case "pick":
          var val = options.options;
          if (this.selected.indexOf(val) === -1) {
            this.selected.push(val);
            this.getByName("btn_" + val).visible = false;

            var l = this.getByName("banner_" + val);
            this.scene.tweens.add({
              targets: l,
              duration: 400,
              y: 1080 + 600,
              scaleY: 0.4,
            });

            if (this.selected.length === 3) {
              this.showHideButtons(false);              
              setTimeout(() => {
                if (
                  this.selected.indexOf(String(this.curSlide.correct)) != -1
                ) {
                  console.log("WRONG - you killed the correct");
                  (this.scene as cScene).triggerSceneEvent("false", {
                    title: this.curSlide.explain_title,
                    info: this.curSlide.explain,
                  });
                } else {
                  this.score++;
                  (this.scene as cScene).triggerSceneEvent("correct", {
                    title: this.curSlide.confirm_title,
                    info: this.curSlide.confirm,
                  });
                }
              }, 1000);
            }
          }

          break;
      }
    });
  }

  private showHideButtons(opt) {
    ["btn_1", "btn_2", "btn_3", "btn_4"].forEach((e: any) => {
      this.getByName(e).visible = opt;
    });

    this.getByName('btn_holder').y = opt ? 0 : 2000;
  }

  private next_question() {
    this.selected = [];

    var c: cContainer = this.getByName("DATA") as cContainer;

    if (this.ccList.length === 0) {
      (this.scene as cScene).triggerSceneEvent("score", { 
        score: ['demo',this.score,this.qData.length].join(':')
      });
    } else {
      this.curSlide = this.ccList.pop();
      (this.scene as cScene).triggerSceneEvent("new", { ...this.curSlide });
    }
  }

  buildScene() {
    super.buildScene();

    var eye1:cSprite = this.getByName('eye_1');
    var eye2:cSprite = this.getByName('eye_2');
    var tg:cContainer = this.getByName('eye_holder');

    this.eyes = [new Eye(this.scene, eye1), new Eye(this.scene, eye2) ]
    
    tg.add(this.eyes[0])
    tg.add(this.eyes[1])

    this.scene.events.on('update', (time, delta)=>{
      this.update();
  }, this);

  }

  update(){
    this.eyes.forEach( el=>el.update())
  }


  mounted() {
    
  }

  closed() {
    this.scene.events.off('update');
  }
}





class Eye extends Phaser.GameObjects.Sprite {

  private init_x: number;
  private ref: cSprite
  private init_y: number;

  constructor(sc:any, ref:cSprite){
    super(sc,0,0,'police','eye.png')
    this.init_x = this.x = ref.x
    this.init_y = this.y = ref.y
    this.ref = ref;
  }

  update(){
    var mX: number =  this.scene.input.mousePointer.x;
    var mY: number =  this.scene.input.mousePointer.y;
    var ang = Phaser.Math.Angle.Between(mX,mY,this.ref.x,this.ref.y);
    var dist = Math.sqrt( (mX-this.ref.x)*(mX-this.ref.x) + (mY-this.ref.y)*(mY-this.ref.y) )
    var len = Math.abs(dist) >4 ? 4 : Math.abs(dist);
    this.x = this.init_x + (Math.cos( ang ) * -len);
    this.y = this.init_y + (Math.sin( ang ) * -len);
  }

}